import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Cluster } from './cluster.interface';

export class ClusterService {
   async getClusters(query?: LocationQuery): Promise<ApiResource<Cluster>> {
      const response = await http.get<ApiResource<Cluster>>(`/clusters`, { params: { ...query } });
      return response.data;
   }

   async get() {
      throw Error('Method not implemented');
   }

   async postCluster(cluster: Cluster) {
      const response = await http.post<ApiResource<Cluster>>(`/clusters`, cluster);
      return response.data;
   }

   async putCluster(clusterId: number, cluster: Cluster) {
      const response = await http.put<ApiResource<Cluster>>(`/clusters/${clusterId}`, cluster);
      return response.data;
   }

   async deleteCluster(clusterId: number) {
      const response = await http.delete(`/clusters/${clusterId}`);
      return response.data;
   }
}
